import { MouseEvent, ReactNode, useEffect } from "react";
import { useModalStore } from "../../../stores/modalStore";
import { ModalBox, CloseButton, ModalSize } from "./styles";
import { Icons } from "../../../icons/Icons";

interface IProps {
  children: ReactNode;
  className?: string;
  onClose?: (e: MouseEvent<HTMLButtonElement>) => void;
  onAutoClose?: () => void;
  showCloseButton?: boolean;
  useBox?: boolean;
  styleBackground?: "normal" | "plane";
  duration?: number;
  size?: ModalSize;
}

export default function ModalTemplate({
  children,
  onClose,
  onAutoClose,
  className,
  showCloseButton = false,
  useBox = true,
  styleBackground = "normal",
  duration,
  size,
}: IProps) {
  useEffect(() => {
    if (duration && duration > 0) {
      const timer = setTimeout(() => {
        if (onAutoClose) {
          onAutoClose();
        } else {
          useModalStore.getState().closeModal();
        }
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onAutoClose]);

  return (
    <>
      {showCloseButton && (
        <CloseButton onClick={onClose || ModalTemplate.preventClose}>
          <Icons name="iconClose" />
        </CloseButton>
      )}

      {useBox ? (
        <ModalBox
          className={className}
          styleBackground={styleBackground}
          $size={size}
        >
          {children}
        </ModalBox>
      ) : (
        // Si no queremos el "box" por defecto, renderizamos children directamente
        <div className={className}>{children}</div>
      )}
    </>
  );
}

ModalTemplate.preventClose = (e: MouseEvent<HTMLButtonElement>) =>
  e.preventDefault();

ModalTemplate.closeModalOnBackgroundClick = () =>
  useModalStore.getState().closeModal();
